import { Actions, ActionTypes } from './actions';
import { LoadingAction } from './loading-action.model';
import { LoadingState, initialState } from './state';
import { get } from 'lodash';

export function loadingReducer(
    state: LoadingState = initialState,
    action: Actions | LoadingAction
) {
    const addLoadingKeyList: string[] = get(action, 'loading.add', null);

    if (addLoadingKeyList) {
        state = {
            // Filter out duplicate keys and append to the array:
            loadingKeys: [
                ...state.loadingKeys.filter(
                    (key) => !addLoadingKeyList.includes(key)
                ),
                ...addLoadingKeyList,
            ],
        };
    }

    const removeLoadingKeyList: string[] = get(action, 'loading.remove', null);
    if (removeLoadingKeyList) {
        state = {
            loadingKeys: state.loadingKeys.filter(
                (key) => !removeLoadingKeyList.includes(key)
            ),
        };
    }

    if ((action as Actions).type === ActionTypes.CLEAR_LOADING) {
        state = { loadingKeys: [] };
    }

    return state;
}
